import { IShop } from '@dash.bar/types'
import { useCallback, useEffect } from 'react'
import api from '../../../../../widgets/shop/api'
import { OrderValueT } from '../../../../../types/widgetDataTypes/types'
import useApiData from '../../../../../hooks/api/useApiData'

const useOrderValue = ({ shop, interval }: { shop: IShop; interval: string }) => {
  const loadData = useCallback(async () => {
    const result: OrderValueT = await api(shop.endpoint, shop.secretToken, {
      body: {
        request: 'Analytics',
        widget: {
          sales: {
            options: {
              active: true,
              details: false,
              interval,
            },
          },
        },
      },
      widget: 'sales',
    })

    return result
  }, [shop, interval])

  const { getData, state } = useApiData(loadData)

  useEffect(() => {
    getData()
  }, [getData])

  return state
}

export default useOrderValue
